import {IUser} from 'types/user';
import api from 'services/axios';
import apiWithRetry from 'services/axiosInstanceRetry';
import {API_ROUTES} from '../constants';
import {BaseResponse} from 'types/api';
import {FIRST_URL, FIRST_REFERRER, LAST_REFERRER, DEVICE_ID, SESSION_ID} from '../constants'
import { getStoredVersion } from 'helpers/ab/abManager';

export async function getUser(): Promise<IUser> {
  const response = await api.get(API_ROUTES.AUTH.USER);
  return response?.data?.user;
}

export async function resetPassword(data: {new_password: string}): Promise<BaseResponse> {
  const response = await api.post(API_ROUTES.PASSWORD.RESET, data);
  return response?.data?.user;
}

export async function sendResetPasswordLink(data: {email: string}): Promise<BaseResponse> {
  const response = await api.post(API_ROUTES.PASSWORD.SEND_LINK, data);
  return response?.data?.user;
}

export const activityStats = async (): Promise<any> => {
  const response = await api.get(API_ROUTES.ACTIVITY_STATS);
  return response?.data?.stats;
}

export const withdrawalsHistory = async (): Promise<any> => {
  const response = await api.get(API_ROUTES.WITHDRAWALS);
  return response?.data?.withdrawals;
}

export const rewardsHistory = async (): Promise<any> => {
  const response = await api.get(API_ROUTES.REWARDS);
  return response?.data?.rewards;
}

// Send event to analytics
export const sendWebEvent = async (event_name: string): Promise<any> => {
  try {
    // Construct the payload for the API request
    const payload = {
      "event_name": event_name,
      "session_id": sessionStorage.getItem(SESSION_ID) || '',
      "device_id": localStorage.getItem(DEVICE_ID) || '',
      "url_path": window.location.pathname,
      "first_url": localStorage.getItem(FIRST_URL) || '',
      "first_referrer": localStorage.getItem(FIRST_REFERRER) || '',
      "version_id": getStoredVersion(),
      "analytics_token": 'Fz&x0J7ntd^W'
    };
    
    const response = await apiWithRetry.post(API_ROUTES.ANALYTICS, payload);
    return response?.data;
  } catch (error) {
    // Pass
  }
}

// Attch (update/ save) the firebase_instance_id per user
export const attachFirebaseInstanceId = async (firebase_instance_id: string): Promise<any> => {
  try {
    const response = await apiWithRetry.post(API_ROUTES.FIREBASE_INSTANCE_ID, { firebase_instance_id });
    return response?.data;
  } catch (error) {
    // Pass
  }
}

export const getSurveysLink = async (): Promise<{surveys_link: string}> => {
  const response = await api.get(API_ROUTES.SURVEYS_LINK);
  return response?.data;
}


// // Mock API calls for testing purposes
// export const earningInProgress = async (): Promise<IOfferItem[]> => {
//   return await new Promise((resolve, reject) => {
//     setTimeout(() => {
//       resolve(mockOfferData);
//     }, 2000);
//   });
// };

// export const earningCompleted = async (): Promise<any[]> => {
//   return await new Promise((resolve, reject) => {
//     setTimeout(() => {
//       resolve(mockOfferDetailsData);
//     }, 2000);
//   });
// };
